import React from "react";
import Modal from "../../../components/common/modal/modal";
import { useTranslation } from "../../../contexts/TranslationContext";
import "./quoteExplanationModal.scss";

type QuoteExplanationModalProps = {
  isVisible: boolean;
  onClose: () => void;
};

const QuoteExplanationModal: React.FC<QuoteExplanationModalProps> = ({
  isVisible,
  onClose,
}) => {
  const t = useTranslation();
  if (!isVisible) return null;

  return (
    <Modal
      isOpen={isVisible}
      onClose={onClose}
      title={t.quoteModal.title}
    >
      <div className="quote-explanation-content">
        <div className="scrollable-content">
          <div>{t.quoteModal.intro}</div>
          <ol>
            <li>{t.quoteModal.resaleRisk}</li>
            <li>{t.quoteModal.operatingCosts}</li>
            <li>{t.quoteModal.marketDemand}</li>
          </ol>
        </div>
      </div>
    </Modal>
  );
};

export default QuoteExplanationModal;
